import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Heart, Mail, Copy, Check, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function Contact() {
    const [copied, setCopied] = useState(false);
    const email = 'contact@meandmypandas.com';

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText(email);
            setCopied(true);
            toast.success('Email copied to clipboard!');
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            toast.error('Failed to copy email');
        }
    };

    return (
        <div className="min-h-screen flex flex-col gradient-bg">
            {/* Navigation Bar */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-lg border-b border-slate-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <Link to="/" className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center">
                                <Heart className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex flex-col sm:flex-row sm:items-baseline sm:gap-2">
                                <span className="font-bold text-lg text-white">Autoimmune Pathways</span>
                                <span className="text-xs sm:text-sm text-slate-400">by Me and My Pandas</span>
                            </div>
                        </Link>
                        <Link to="/">
                            <Button variant="ghost" className="text-slate-300 hover:text-white">
                                <ArrowLeft className="w-4 h-4 mr-2" />
                                Back
                            </Button>
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <div className="flex-1 flex items-center justify-center p-6 pt-24">
                <div className="w-full max-w-lg text-center">
                    {/* Email Icon */}
                    <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mx-auto mb-8">
                        <Mail className="w-10 h-10 text-teal-600" />
                    </div>

                    {/* Heading */}
                    <h1 className="text-3xl font-bold text-foreground mb-4">Contact Us</h1>
                    <p className="text-muted-foreground text-lg mb-8">
                        Have questions or feedback? We'd love to hear from you!
                    </p>

                    {/* Email Card */}
                    <Card className="bg-slate-50 dark:bg-slate-800/50 border-0 shadow-sm mb-6">
                        <CardContent className="p-6">
                            <p className="text-sm text-muted-foreground mb-3">Send us an email at:</p>
                            <div className="flex items-center justify-center gap-3">
                                <a 
                                    href={`mailto:${email}`}
                                    className="text-xl font-medium text-teal-600 hover:text-teal-700 transition-colors"
                                >
                                    {email}
                                </a>
                                <Button
                                    variant="outline"
                                    size="icon"
                                    onClick={copyEmail}
                                    className="h-10 w-10 border-teal-200 hover:bg-teal-50 dark:border-slate-600 dark:hover:bg-slate-700"
                                    data-testid="copy-email-btn"
                                >
                                    {copied ? (
                                        <Check className="w-4 h-4 text-green-600" />
                                    ) : (
                                        <Copy className="w-4 h-4 text-teal-600" />
                                    )}
                                </Button>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Response Time */}
                    <p className="text-sm text-muted-foreground">
                        We typically respond within 24-48 hours.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <footer className="py-6 text-center">
                <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    ← Back to Home
                </Link>
            </footer>
        </div>
    );
}
